import CryptoJS from "crypto-js";
import {nanoid} from "nanoid";
import getCosUploading from "@/utils/cos.config";
import {Toast} from "vant";
import {EventBus} from "@/store/eventBus";
export function isTimestampExpired(expireTime) {
    // 将当前时间转换为秒（因为 expireTime 是以秒为单位的）
    const currentTimeInSeconds = Math.floor(Date.now() / 1000) + 60
    // 比较当前时间和过期时间
    if(currentTimeInSeconds >= Number(expireTime)){
        return true;
    }

}
export const fileTypeList = ['png', 'jpg', 'jpeg', 'gif', 'mp4', 'mrv', 'mov', 'mpg', 'mpeg', 'ts', 'swf', 'flv', 'wmv', 'avi', 'mkv', 'aac', 'flac', 'ogg', 'ape', 'wav', 'mp3', 'wma', 'pdf', 'xls', 'xlsx']

export function decode(data) {
    try {
        var keyHex = CryptoJS.enc.Utf8.parse('yishengtechnologycompany20190411')
        var ivHex = CryptoJS.enc.Utf8.parse('yishengtech@2019')
        var encryptedHexStr = CryptoJS.enc.Hex.parse(data)
        var srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr)
        var decrypt = CryptoJS.AES.decrypt(srcs, keyHex, {
            iv: ivHex,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        })
        var decryptedText = CryptoJS.enc.Utf8.stringify(decrypt)
        if (!decryptedText && decrypt.sigBytes < 0) {
            console.error("Decryption failed: Negative signature bytes")
        }
        return decryptedText
    } catch (e) {
        console.error("Decryption failed:", e)
    }
    return ''
}
export function getFileSuffix(name) {
    let suffix = name.split(".")
    return suffix[suffix.length - 1]

}
//uuid
function  generateUUID() {
    const id = nanoid()
    return id
}
//生成随机路径和名称
export function generateFilePath(fileType,typeUpload) {
    // 获取当前日期
    const now = new Date();
    // 获取年、月、日，并确保月和日格式始终是两位数
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, '0'); // 月份是从0开始的
    const day = now.getDate().toString().padStart(2, '0');
    const randomChars = generateUUID().replace(/[_-]/g, ''); // 使用之前的generateUUID函数，并去除破折号
    // 构建文件名
    const fileName = `${randomChars}${fileType}`;
    // 拼接完整的路径
    const filePath = `/${typeUpload}/${year}/${month}/${day}/${fileName}`;
    return filePath;
}


// 处理文件分类
export function classifyFileTypes(extension) {
    const fileTypes = {
        videoType: ['.mp4', '.mrv', '.mov', '.mpg', '.mpeg', '.ts', '.swf', '.flv', '.wmv', '.avi', '.mkv'],
        audioType: ['.aac', '.flac', '.ogg', '.ape', '.wav', '.mp3', '.wma'],
        docType: ['.pdf', '.xls', '.xlsx'],
        imageType: ['.jpg', '.jpeg', '.png', '.gif'],
    }
    if (fileTypes.videoType.includes(extension)) {
        return 'video';
    } else if (fileTypes.audioType.includes(extension)) {
        return 'audio';
    } else if (fileTypes.docType.includes(extension)) {
        return 'doc';
    } else if (fileTypes.imageType.includes(extension)) {
        return 'image';
    }
}

export  async function  handleUploadFile($ajax) {
    const checkAndUpdateCredentials = async () => {
        const expireTime = localStorage.getItem("expireTime");

        if (expireTime === 'undefined' || isTimestampExpired(expireTime)) {
            try {
                const res = await $ajax({
                    url: '/etv/getCosCredential.json',
                    method: 'post',
                    headers: {
                        'token': localStorage.getItem('token1'),
                    },
                });
                var jsonString = decode(res.data.data)
                var data = JSON.parse(jsonString)
                if (data !== null) {
                    localStorage.setItem("bucketName", data.bucketName);
                    localStorage.setItem("region", data.region);
                    localStorage.setItem("tmpSecretId", data.tmpSecretId);
                    localStorage.setItem("tmpSecretKey", data.tmpSecretKey);
                    localStorage.setItem("sessionToken", data.sessionToken);
                    localStorage.setItem("expireTime", data.expireTime);
                }
            } catch (error) {
                console.error("Failed to get new credentials", error);
                throw error;
            }
        }
    };
    await checkAndUpdateCredentials()
}
/**
 * 上传图片
 * @param file
 * @param index
 */
export function upFileImage(file,id,$ajax) {
    return new Promise((resolve) => {
        // 源文件
        const suffix = getFileSuffix(file.name)
        let type = '.' + suffix.toLowerCase()
        let typeUpload = classifyFileTypes(type)
        let primaryName = generateFilePath(type, typeUpload)
        const uploadStatus={}
        getCosUploading().uploadFileCos(`${primaryName}`, file,
            (progressData) => {
                uploadStatus.complete = Math.floor(progressData.percent * 100);
                // 这里决定是否立即调用 resolve，或者在某个条件下调用
                resolve(uploadStatus) // 如果你希望每次进度更新都触发 resolve
            },
            (err) => {
                if (err === null) {
                    console.log(err);
                }
            },
            (err, data) => {
                /* console.log(err,data)*/
                if (err === null) {
                    let cosUrl = data.Location

                    $ajax({//查询在线设备离线设备等
                        url: '/etv/createMaterial.json',
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json',
                            'token': localStorage.getItem('token'),
                        },
                        data: JSON.stringify({
                            "mtUrl": cosUrl,
                            "thumbnailUrl": typeUpload === 'video'?data.thumbnailUrl:"",
                            "mtSize": file.size,
                            "mtMfId": id,
                            "mtOgnName": file.name,

                        }),
                    }).then(res => {
                        if (res.data.code === 0) {
                            Toast(res.data.msg)
                            uploadStatus.success = true
                            resolve(uploadStatus)
                            setTimeout(() => {
                            EventBus.$emit('upload-success')
                            }, 2000)

                        } else {
                            Toast(this.$t('append_field.cancelAllUploads'))
                        }
                    })
                }
            },
            (taskId) => {
                uploadStatus.taskId=taskId
                resolve(uploadStatus) // 触发 resolve
            }
        )
    })
}
